module.exports = __webpack_public_path__ + "static/media/tap_07_img01.b55be74c.png";